import React from 'react';

const Record = ({ className = '', title = '' }) => {
  return (
    <svg className={className} width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title lang="en">{title}</title>
      <circle cx="17" cy="17" r="13" fill="#F36A27"/>
      <circle cx="17" cy="17" r="16.5" stroke="black"/>
    </svg>
  )
};

export default Record;
